import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import AdminBHULessonProgressCard from 'components/AdminBHULessonProgressCard'
import AdminGradeList from 'components/AdminGradeList'
import AdminLessonProgressCard from 'components/AdminLessonProgressCard'
import AdminLessonProgressTabs from 'components/AdminLessonProgressTabs'
import AdminNoClasses from 'components/AdminNoClasses'
import { getMspDigitalFromPreferences } from 'utils/sitePreferenceHelpers'
import AdminSiteHeader from 'components/AdminSiteHeader'
import { LESSON_COMPLETION_SPECIALIZED_UNITS_LABEL } from 'components/AdminSiteHeader/constants'
import { DIGITAL_WELL_BEING_UNIT_LABEL } from 'store/reportsManager/lessonCompletionHelpers'
import { SpinnerAnimatedIcon } from 'secondstep-components'
import {
  BodyWrapper,
  LoadingWrapper,
  SingleSiteWrapper,
  StyledHairline,
} from './component.styles'

const AdminSingleSiteView = ({
  isCoreUnitsView = false,
  isFetchingLessons,
  isSpecializedUnitsView = false,
  lessonCompletionUnitsLabel,
  showEmptyDwbReport = false,
  showLessonCompletionExport,
  sites,
  sitesPreferences,
  summary,
}) => {
  if (isFetchingLessons) {
    return (
      <SingleSiteWrapper>
        <LoadingWrapper>
          <SpinnerAnimatedIcon />
          <p>Loading...</p>
        </LoadingWrapper>
      </SingleSiteWrapper>
    )
  }
  if (
    (summary && Array.isArray(sites)) ||
    lessonCompletionUnitsLabel === LESSON_COMPLETION_SPECIALIZED_UNITS_LABEL
  ) {
    const isSpecializedUnits =
      lessonCompletionUnitsLabel === LESSON_COMPLETION_SPECIALIZED_UNITS_LABEL
    const {
      name: siteName,
      classesCreated,
      units,
      grades,
      siteId,
      summary: siteSummary,
    } = sites?.[0] || {}
    const filteredGrades = isSpecializedUnits
      ? grades?.[DIGITAL_WELL_BEING_UNIT_LABEL]
      : grades
    const hasBHUEnabled =
      getMspDigitalFromPreferences(sitesPreferences[siteId])
        ?.bullyingHarassmentUnitEnabled ?? false
    const hasBHUClassCreated = siteSummary?.unit5?.classesCreated > 0
    const bhuStatus = hasBHUEnabled && hasBHUClassCreated

    return (
      <SingleSiteWrapper>
        <AdminSiteHeader
          classesCreated={summary?.classesCreated}
          classesNotStarted={summary?.classesNotStarted}
          core={summary?.core}
          etlLastUpdatedAt={summary?.etlLastUpdatedAt}
          hideSummary={isSpecializedUnits}
          lessonCompletionUnitsLabel={
            lessonCompletionUnitsLabel || 'Core Units'
          }
          lessonsCompleted={summary?.lessonsCompleted}
          lessonsTotal={summary?.lessonsTotal}
          showLessonCompletionExport={showLessonCompletionExport}
          showSummaryText={isSpecializedUnits}
          singleSite
          siteId={siteId}
          siteName={siteName}
          sitesPreferences={sitesPreferences}
          sitesTotal={summary?.sitesTotal}
          unit5={summary?.unit5}
        />
        {summary?.classesCreated > 0 && !showEmptyDwbReport && (
          <Fragment key="single-site-1">
            <StyledHairline />
            {!isSpecializedUnits && <AdminLessonProgressTabs outline={true} />}
          </Fragment>
        )}
        <BodyWrapper
          isDwbEmptyReport={showEmptyDwbReport}
          noClasses={summary?.classesCreated === 0 && !showEmptyDwbReport}
        >
          {(summary?.classesCreated === 0 || showEmptyDwbReport) && (
            <AdminNoClasses
              isCoreUnitsView={isCoreUnitsView}
              isDwbEmptyReport={showEmptyDwbReport}
              isSpecializedUnitsView={isSpecializedUnitsView}
            />
          )}
          {summary?.classesCreated > 0 && !showEmptyDwbReport && (
            <Fragment key="single-site-2">
              {!isSpecializedUnits && (
                <AdminLessonProgressCard
                  bhuStatus={bhuStatus}
                  summary={siteSummary}
                  units={units}
                />
              )}
              {isSpecializedUnits && (
                <AdminSiteHeader
                  classesCreated={summary?.classesCreated}
                  classesNotStarted={summary?.classesNotStarted}
                  etlLastUpdatedAt={summary?.etlLastUpdatedAt}
                  isSpecializedUnits={isSpecializedUnits}
                  lessonCompletionUnitsLabel={
                    lessonCompletionUnitsLabel || 'Core Units'
                  }
                  lessonsCompleted={summary?.lessonsCompleted}
                  lessonsTotal={summary?.lessonsTotal}
                  singleSite
                  siteId={siteId}
                />
              )}
              <StyledHairline extraMargin={true} />
              <AdminGradeList
                dwbProgressBars={isSpecializedUnits}
                grades={filteredGrades}
                isSpecializedUnits={isSpecializedUnits}
                siteId={siteId}
                splitTwoColumns={isSpecializedUnits}
              />
            </Fragment>
          )}
        </BodyWrapper>
        {bhuStatus && (
          <AdminBHULessonProgressCard
            classesCreated={classesCreated}
            grades={filteredGrades}
            siteId={siteId}
            summary={siteSummary}
          />
        )}
      </SingleSiteWrapper>
    )
  }
  return null
}

AdminSingleSiteView.propTypes = {
  isCoreUnitsView: PropTypes.bool,
  isFetchingLessons: PropTypes.bool,
  isSpecializedUnitsView: PropTypes.bool,
  lessonCompletionUnitsLabel: PropTypes.string.isRequired,
  showEmptyDwbReport: PropTypes.bool,
  showLessonCompletionExport: PropTypes.bool,
  sites: PropTypes.array,
  sitesPreferences: PropTypes.object,
  summary: PropTypes.object,
}

export default AdminSingleSiteView
